/**
 * <pre>
 * Datetime utility functions.
 *
 * Summary of responsibilities:
 *
 *  - provides commonly used functionality that can be called from anywhere.
 * </pre>
 *
 * @author Various
 * @namespace Common.Utils.DateTime
 */

// Import core lib dependencies.
import moment from 'moment';

/**
 * Returns a formatted date using relative time.
 *
 * @memberOf Common.Utils.DateTime
 *
 * @param theDate : {date}
 * @param format  : {string}
 * @returns {string}
 */
function getRelativeDate(theDate = new Date(), format = 'D MMMM YYYY') {
  const _oneWeekAgo = moment().subtract(1, 'weeks');
  const _moment = moment(theDate);
  if (!!NGX.context.locale && NGX.context.locale !== 'ml_ML') {
    _moment.locale(NGX.context.locale);
  }

  if (_moment.isBefore(_oneWeekAgo)) {
    return _moment.format(format);
  } else {
    return _moment.fromNow();
  }
}
export { getRelativeDate };

/**
 * Returns a formatted date.
 *
 * @memberOf Common.Utils.DateTime
 *
 * @param theDate : {date}
 * @param format  : {string}
 * @returns {string}
 */
function getDateTime(theDate = new Date(), format = 'DD MMMM YYYY HH:mm') {
  const _moment = moment(theDate);
  if (!!NGX.context.locale && NGX.context.locale !== 'ml_ML') {
    _moment.locale(NGX.context.locale);
  }

  return _moment.format(format);
}
export { getDateTime };
